var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"pa-4"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":10,"sort-by":['id'],"sort-desc":"","hide-default-footer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }